import React from "react";
import {AudienceType, SegmentFinder} from "./AudienceFinder";
import {
    EuiFieldSearch,
    EuiFlexGroup,
    EuiFlexItem,
    EuiFormRow,
    EuiPanel,
    EuiRadio,
    EuiSpacer,
    EuiTitle, htmlIdGenerator
} from "@elastic/eui";
import BillboardFinder from "./BillboardFinder";

export const AudienceSearcher: React.FC = () => {
    const [audienceType, setAudienceType] = React.useState<AudienceType>(AudienceType.Internet);
    const [cityName, setCityName] = React.useState<string>('');

    return (
        <EuiFlexGroup>
            <EuiFlexItem>
                <EuiPanel hasBorder={true} hasShadow={false}>
                    <EuiTitle size={'s'}>
                        <h2>Explore Available Audiences</h2>
                    </EuiTitle>
                    <EuiSpacer/>
                    <EuiFormRow fullWidth>
                        <EuiFlexGroup responsive={false} wrap>
                            <EuiFlexItem grow={false}>
                                <EuiRadio label={'Internet'} id={'Internet Segments'} onChange={() => setAudienceType(AudienceType.Internet)} checked={audienceType === AudienceType.Internet} />
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <EuiRadio label={'TV'} id={'Tv Segments'} onChange={() => setAudienceType(AudienceType.Tv)} checked={audienceType === AudienceType.Tv} />
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiFormRow>
                    <EuiFormRow label={'Audience Segments'} fullWidth>
                        <SegmentFinder isInvalid={false} onSegmentClicked={() => {}} mode={audienceType} />
                    </EuiFormRow>
                </EuiPanel>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiPanel hasBorder={true} hasShadow={false}>
                    <EuiTitle size={'s'}>
                        <h2>Explore Billboard Locations</h2>
                    </EuiTitle>
                    <EuiSpacer/>
                    <EuiFormRow label={'Search City'}>
                        <EuiFieldSearch
                            id={htmlIdGenerator()()}
                            autoComplete='off'
                            fullWidth
                            compressed
                            value={cityName}
                            onChange={v => setCityName(v.target.value)}
                            incremental={false}
                            placeholder='Type city...'
                        />
                    </EuiFormRow>
                    <EuiSpacer/>
                    <BillboardFinder  suggestedPlaces={cityName.length > 2 ? [cityName] : []}/>
                </EuiPanel>
            </EuiFlexItem>
        </EuiFlexGroup>
    )
}